export default __webpack_public_path__ + "static/media/img7.dc472de8.png";